import api from "./api";

const endpoint = '/imagemChamado_';

export const getImagensByChamado = async (chamado) => {
    try {
        const response = await api.post(endpoint + "/byChamado", chamado);
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
}